import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromMailModules from './reducers/mail-module.reducer';
import * as fromMailGroup from './reducers/mail-group.reducer';
import { EffectsModule } from '@ngrx/effects';
import { MailModuleEffects } from './effects/mail-module.effects';
import { MailGroupEffects } from './effects/mail-group.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('mailModuleList', fromMailModules.reducer),
    StoreModule.forFeature('mailGroupList', fromMailGroup.reducer),
    EffectsModule.forFeature([MailModuleEffects, MailGroupEffects])
  ]
})
export class MailModule { }
